import React from 'react';
import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

interface CustomButtonProps extends ButtonProps {
  label: string;
}

const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  padding: theme.spacing(1, 3),
  borderRadius: theme.shape.borderRadius * 5,
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightBold,
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'translateY(-1px)',
    boxShadow: theme.shadows[3],
  },
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.info.light}`,
    outlineOffset: 2,
  },
}));

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disableElevation = true,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      color={color}
      size={size}
      disableElevation={disableElevation}
      {...props}
    >
      {label}
    </StyledButton>
  );
};

export default CustomButton;
